import React, { Component } from 'react';
import { FormControl, Button, Row, Col} from 'react-bootstrap';
import { translate } from "react-i18next";


function emptyUser(eventId) {
    if(eventId > 0 ){
        return {eventId:eventId, username:'', email:'', invitationStatus:'INVITED'};
    } else {
        return  {username:'', email:''};
    }
}

class InvitedAdd extends Component {

    constructor(props) {
        super(props);

        this.onInvitedAdd = this.onInvitedAdd.bind(this);
        this.onInvitedInputChange = this.onInvitedInputChange.bind(this);

        this.state = {
            user: emptyUser(this.props.eventId ? this.props.eventId:0 )

        }
    }

    onInvitedAdd() {
        this.props.onAdd(this.state.user);
        let y = emptyUser(this.props.eventId ? this.props.eventId:0 );
        const { oldState } = this.state;
        this.setState({
            ...oldState,
            user: y
        });
    }

    onInvitedInputChange(obj) {
        const { name: fieldName, value: fieldValue } = obj.target;
        const { user } = this.state;

        const newUser = {
        ...user,
        [fieldName]: fieldValue
        };

        this.setState({
            user: newUser
        });
    }
    
    render() {
        const { t } = this.props;
        const { user: {username, email} } = this.state;
        return (
               <div className="greyBg p-2 mt-3">
               
                <Row>
                    <Col lg={4} md={8}>
                    <FormControl
                        placeholder={t("fullname")}
                        onChange={this.onInvitedInputChange}
                        name="username"
                        value={username}
                    />
                    </Col>
                   
                    <Col lg={5} md={8}>
                    <FormControl
                        placeholder={t("yourEmail")}
                        onChange={this.onInvitedInputChange}
                        name="email"
                        value={email} 
                    />
                    </Col>
                  
                     <Col lg={3} md={8}>
                        <Button variant="success "  onClick={this.onInvitedAdd} className="float-right">{t("TeilnehmerHinzufuegen")}</Button>
                    </Col>
                    </Row>
               
                
                </div>
        )
    }
}
export default translate("translations")(InvitedAdd);